<template>
  <section class="chapter4">
    <div class="container top-container">
      <Count>4</Count>
      <Title>De smet op jouw pakket</Title>
      <Content>
        <p>Heen en weer met al die pakjes, alles uitpakken, controleren en weer inpakken. We weten inmiddels: dat kost allemaal enorm veel geld. Maar goed, als bedrijven dat willen betalen, prima. Hun keuze. Maar het klinkt allemaal niet heel duurzaam. Hoe zit dat?</p>
        <p>Om daar iets over te zeggen moeten we eigenlijk eerst kijken naar de hele pakjesindustrie. En als het gaat om impact op het milieu, draait het om twee belangrijke dingen: de uitstoot van CO2 en verpakkingen.</p>
        <h3>CO2</h3>
        <p>In Nederland rijden zo’n 5000 busjes rond die pakketten bezorgen. Dat lijkt veel, maar in heel Nederland zijn in totaal 876.000 busjes. De meeste bussen die je ziet op de weg hebben dus niks met pakjes te maken, maar zijn bijvoorbeeld voor de bouw of horeca.</p>
        <p>Al die bussen bij elkaar stoten natuurlijk best wat CO2 uit - ook al komen er steeds meer elektrische busjes bij. Sterker nog, we kunnen zelfs even kijken hoeveel CO2-uitstoot jij veroorzaakt, op basis van het aantal pakjes dat jij aan het begin hebt ingevuld.</p>
      </Content>
      <CO2Calc />
      <Content>
        <p>De grote vraag: maken retourzendingen dat erger? Het korte antwoord: een beetje. Dingen terugsturen via een afhaalpunt is niet zo erg, busjes die toch wel terug moeten rijden halen het dan op. Mits je niet met de auto je pakje daarheen brengt natuurlijk.</p>
        <p>Een groter probleem is de ruimte die al die extra pakjes innemen. Dat geldt vooral voor alle vrachtwagens die heen en weer rijden tussen sorteercentra en distributiecentra. Die zitten simpelweg voller door alle retouren.</p>
        <p>Bij busjes speelt dat probleem minder. Hoeveel pakjes er in een busje gaan wordt vooral beperkt door hoeveel adressen een bezorger per dag kan bezoeken.</p>
      </Content>
    </div>
    <section class="box">
      <div class="container box-container">
        <Plaster1 class="plaster plaster-left" />
        <Plaster2 class="plaster plaster-right" />
        <Content>
          <h3>Verpakkingen</h3>
          <p>Naast CO2 speelt de verpakking van je pakjes ook een grote rol. En dat draait allemaal om één ding…</p>
        </Content>
        <AirBox />
        <Content>
          <p>Zeven van de tien pakjes zijn van karton. In kartonnen pakketten zit heel veel lucht, vaak tot 50 procent van de inhoud van een pakje. Dat vinden consumenten niet alleen heel irritant, pakketjes zijn daardoor ook groter dan nodig. Er passen dus minder pakjes in een busje, waardoor die vaker moeten rijden.</p>
          <p>Al die extra lucht zorgt voor grotere pakketten en dus ook meer karton en plastic. Voor de grote bedrijven is dit makkelijker op te lossen dan de kleine. Die kunnen enorme machines aanschaffen die elk pakje individueel inpakken. Voor kleinere webshops is dat lastiger. Die bestellen vaak gewoon een paar honderd grote dozen, en daar gooien ze dan alles in.</p>
          <p>Zo veel lucht zit er in jouw pakjes:</p>
        </Content>
      </div>
      <PackageContentSlider />
      <div class="container">
        <Content>
          <p>Wat kan helpen is op een andere manier berekenen hoe duur het verzenden van een pakje is. In Nederland bepaalt het gewicht de verzendkosten. In Amerika zijn ze sinds een paar jaar overgestapt naar een formule die ook het volume van je pakje meeneemt. Dat dwingt bedrijven om pakketten zo klein mogelijk te versturen.</p>
          <p>Maar niet alleen bedrijven kunnen iets doen. Jij ook. Veel onnodige CO2-uitstoot zit ‘m in mensen die met de auto naar ophaalpunten gaan om iets te halen of retouren te brengen. Als je 10 kilometer moet rijden voor een pakje, kan je het beter thuis laten bezorgen.</p>
          <p>Hoe sneller jij je pakje in huis wil, hoe meer CO2 het kost. Vooral ‘same day delivery’ heeft veel impact, busjes moeten dan speciaal voor jou rijden. Qua retouren: als je retouren kan teruggeven aan de bezorger als die iets nieuws bezorgt, is dat het meest duurzaam. Als je iets terugstuurt: plak het niet helemaal vol met tape en gebruik een zo klein mogelijke doos of zak.</p>
        </Content>
      </div>
    </section>
  </section>
</template>

<script>
import { Title, Count, Content } from '@/components/chapter'
import { Plaster1, Plaster2 } from '@/components/icons'
import CO2Calc from '@/components/co2-calc'
import PackageContentSlider from '@/components/package-content-slider'
import AirBox from '@/components/air-box'
import { chapterMixin } from '@/mixins'

export default {
  name: 'Chapter4',
  mixins: [chapterMixin],
  components: {
    Plaster1,
    Plaster2,
    Title,
    Count,
    Content,
    CO2Calc,
    PackageContentSlider,
    AirBox
  }
}
</script>

<style lang="scss" scoped>
.chapter4 {
  background-color: $c-dark;
  padding-top: 3em;
}

.top-container {
  position: relative;
  z-index: 2;
}

.plaster {
  position: absolute;
}

.plaster-left {
  top: -29px;
  left: 0;
}

.plaster-right {
  position: absolute;
  top: -22px;
  right: 0;
}

.box {
  background-color: $c-brown;
  padding-bottom: 4em;
  margin-top: 5em;

  @media (max-width: 767px) {
    padding-bottom: 3em;
    margin-top: 4em;
  }
}

.box-container {
  padding-top: 4em;
  position: relative;

  @media (max-width: 767px) {
    padding-top: 3em;
  }
}
</style>
